function e(e){return Object.entries(e).filter((([e,t])=>""!==e&&t)).map((([e])=>e)).join(" ")}export{e as classMap};
//# sourceMappingURL=classMap.js.map
